import { KnockoutCompetition, RoundRobinCompetition } from './competition';

export const SeasonStatus = /* @__PURE__ */ Object.freeze({
  DRAFT: 'Draft',
  ACTIVE: 'Active',
  COMPLETE: 'Complete',
});

export type SeasonStatus = (typeof SeasonStatus)[keyof typeof SeasonStatus];

export interface SeasonData {
  /**
   * slug (PK)
   */
  id: string;
  /**
   * More readable version of the slug
   */
  displayName: string;
  /**
   * Creation timestamp (ms precision)
   */
  created: number;
  /**
   * Lifecycle stage.
   */
  status: SeasonStatus;
  /**
   * Competition data
   */
  competitions: {
    eightBallRoundRobin?: RoundRobinCompetition;
    eightBallKnockout?: KnockoutCompetition;
    // May introduce nineBallLeague and nineBallCup here in the future
  };
  /**
   * Previous season ID
   */
  prev?: string;
  /**
   * Next season ID
   */
  next?: string;
}

export type SeasonDataSansCompetitions = Omit<SeasonData, 'competitions'>;

export type NewSeasonPostBody = Pick<SeasonData, 'displayName'>;

export type UpdateSeasonPatchBody = Partial<
  Pick<SeasonData, 'displayName' | 'status'>
>;
